import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  ActivityIndicator,
} from 'react-native';
import {
  Button, Input,
} from 'react-native-elements';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import { Rating } from 'react-native-ratings';
import { ifIphoneX } from 'react-native-iphone-x-helper';

import starStandard from '../../../node_modules/react-native-ratings/src/images/star.png'; // FIXME(clairbee): fix webpack config instead

import {
  reviewValidation,
} from '../../modules/validation/Review';

import { AppSyncClientUnauthenticated, AppSyncClientAuthenticated } from '../../backends/AppSyncClient';
import GetApp from '../../q/GetApp';
import SubmitReview from '../../q/SubmitReview';
import App from '../../modules/data/App';
import AppBadge from '../../components/apps/AppBadge';

// import AORTypes from '../../types';
import styles from '../../styles';
import { translate } from '../../locales/i18n';

const validationSchema = yupObject().shape({
  review: reviewValidation,
});

class Review extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleCancel = this.handleCancel.bind(this);

    this.displayName = 'Review';

    this.state = {
    };
  }

  handleCancel(_values, _formikBag) {
    const { history } = this.props;

    history.push('/ai-agents');
  }

  handleSave(values, formikBag) {
    const {
      onSave,
    } = this.props;

    formikBag.setSubmitting(true);

    onSave(values).then((result) => {
      console.log('review onSave result');
      console.log(result);

      this.handleCancel();
    });
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
  }) => {
    console.log('render form');
    console.log(values);

    return (
      <View
        style={[styles.form.containerFullScreen, {
          flex: undefined,
          flexShrink: 1,
          flexDirection: 'column',
          alignSelf: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }]}
      >
        <Rating
          style={{
            marginTop: 10,
          }}
          type="custom"
          ratingImage={starStandard}
          minValue={1}
          startingValue={values.rating}
          ratingCount={5}
          fractions={0}
          ratingBackgroundColor="#c8c7c8"
          imageSize={50}
          onStartRating={() => {
            console.log('onStartRating');
          }}
          onFinishRating={(rating) => {
            console.log('rating');
            console.log(rating);
            setFieldTouched('rating');
            setFieldValue('rating', rating);
          }}
        />
        <Input
          containerStyle={[styles.form.inputContainer, { flex: 1, width: '100%' }]}
          labelStyle={styles.form.inputLabel}
          inputStyle={[styles.form.inputInput, { paddingVertical: 10 }]}
          inputContainerStyle={touched.review && errors.review ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
          label={`${translate('review')}:`}
          value={values.review}
          multiline
          numberOfLines={5}
          placeholder={translate('review_placeholder')}
          onChangeText={(value) => setFieldValue('review', value)}
          onBlur={() => setFieldTouched('review')}
          errorMessage={touched.review && errors.review ? errors.review : undefined}
          placeholderTextColor="grey"
          autoFocus
        />
        <View style={{
          backgroundColor: 'white',
          justifyContent: 'center',
          flexDirection: 'row',
          paddingBottom: ifIphoneX(10, 0),
          paddingTop: 10,
        }}
        >
          <Button
            title={translate('button_cancel')}
            containerStyle={styles.button.secondaryContainer}
            buttonStyle={styles.button.secondary}
            disabledStyle={styles.button.secondaryDisabled}
            titleStyle={styles.button.secondaryTitle}
            disabledTitleStyle={styles.button.secondaryTitleDisabled}
            onPress={() => this.handleCancel(values)}
          />
          <Button
            title={translate('button_save')}
            containerStyle={styles.button.primaryContainer}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={handleSubmit}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
        </View>
      </View>
    );
  }

  render() {
    const {
      app, direction,
    } = this.props;
    const { error } = this.state;

    if (!app || !app.data) {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    app.postProcess();

    return (
      <View style={styles.view.headed}>
        <View
          style={[styles.view.form, {
            height: '100%',
            backgroundColor: 'white',
            flexDirection: direction,
            justifyContent: 'center',
          }]}
        >
          <View
            style={{
              height: 148,

              alignSelf: 'center',
              maxWidth: 500,
              width: direction === 'column' ? '90%' : '45%',
              marginTop: 60,
              marginBottom: 10,
              marginHorizontal: 20,
            }}
          >
            <AppBadge
              style={{
                minWidth: 310,
                maxWidth: 500,
              }}
              data={app.data}
            />
          </View>
          <Formik
            initialValues={{
              error,
              rating: 5,
              review: '',
            }}
            enableReinitialize
            validateOnMount
            onSubmit={(values, formikBag) => this.handleSave(values, formikBag)}
            validationSchema={validationSchema}
          >
            {this.renderForm}
          </Formik>
        </View>
      </View>
    );
  }
}

Review.defaultProps = {
  app: null,
};

Review.propTypes = {
  app: PropTypes.instanceOf(App),
  onSave: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string.isRequired,
};

export default compose(
  graphql(GetApp, {
    props: (props) => {
      console.log('graphql props');
      console.log(props);
      if (!props.data.getApps) {
        return {};
      }
      const app = App.createFromData(props.data.getApps);
      if (app && app.data && app.data.endpoints === undefined) {
        app.data.endpoints = [];
      }
      return {
        app,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.match.params.uuid,
      },
      client: AppSyncClientUnauthenticated,
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientUnauthenticated,
  }),
  graphql(SubmitReview, {
    props: (props) => ({
      onSave: (values) => props.mutate({
        variables: {
          app: props.ownProps.match.params.uuid,
          rating: values.rating,
          review: values.review,
        },
      }),
    }),
    options: (props) => ({
      client: AppSyncClientAuthenticated(props.user),
    }),
  })
)(Review);
